import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { sendOtp } from "../lib/api";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { cn } from "../shared/utils";
import { Spinner } from "../shared/svgIcon";
import { useStore } from "../store";
export default function SignIn(props) {
  let navigate = useNavigate();
  const location = useLocation();
  const from = new URLSearchParams(location.search).get("from");
  const [error, setError] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [isDelete, setIsDelete] = useState(false)
  const setProfileDeletion = useStore((state) => state.setProfileDeletion)
  useEffect(() => {
    // console.log(location, "loc", q);
    if (from == 'delete') {
      setIsDelete(true);
      setProfileDeletion(true)
    }else{
      setProfileDeletion(false)
    } 
  }, [from]);
  const signIn = async () => {
    try {
      // console.log("sign", phone);
      setError("");
      if (!phone) return;
      setLoading(true);
      const res = await sendOtp({
        contact: phone,
        type: "phone",
      });
      // console.log(res);

      if (res?.isSuccess) {
        if (phone) sessionStorage.setItem("patientPhone", phone);
        sessionStorage.setItem("otp_timeout",res?.data?.result?.otp_timeout)
        navigate("/otp");
      } else {
        // console.log(res);
        setError(res?.data?.message || "try again");
        setLoading(false);
      }
    } catch (error) {
      console.log(error, "rr");
      setLoading(false);
    }
  };
  const gotoSignup = () => {
    navigate("/signup");
  };

  return (
    <>
      <div className="bg-primary text-white   relative  flex flex-col dh-screen">
        <div className="z-20 relative px-6 py-4  sm:w-3/5 ">
          <div className="flex w-full">
            <div className="flex-1 mt-4 mx-auto">
              <img src="../../../images/Logo.svg" alt="logo" className="mb-4" />
            </div>
          </div>

          <div className="text-left font-bold mb-2">
            <>
              <span className="text-2xl  capitalize">Sign in</span> <br />
            </>
          </div>
        </div>
        <div className="overflow-hidden bg-white w-full pb-6 rounded-t-2xl flex flex-col sm:w-3/5 mx-auto text-black flex-1 justify-between">
          <div className="flex flex-col  pt-4 mx-4 flex-1">
            <div className="py-3 ">
              <span className="text-slate-700 text-xl font-medium ">
                Sign in to get{" "}
              </span>
              <span className="text-slate-700 text-xl font-bold ">Code</span>
            </div>
            <div className=" text-slate-700 text-base font-normal ">
              You will receive a 6 digit code for phone number verification
            </div>
            <div className="flex flex-col">
              <div className="flex flex-col  w-full pt-3">
                <label
                  htmlFor="phone"
                  className="text-black text-base font-medium font-['SF Pro Display'] pl-1 "
                >
                  Phone
                </label>
                <div className="flex">
                  <PhoneInput
                    name="phone"
                    rules={{ required: true }}
                    international
                    countryCallingCodeEditable={false}
                    defaultCountry="IN"
                    autoComplete="off"
                    onChange={(e) => setPhone(e)}
                    numberInputProps={{
                      className: " bg-gray-200 focus-visible:outline-none",
                    }}
                    className=" bg-gray-200  flex  w-full h-12 rounded-lg border border-input  px-3 py-2 mt-2 text-base shadow-sm transition-colors   focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                  />
                </div>
              </div>
              {error && <div className="pt-2 text-red-600 text-sm">{error}</div>}
              <button
                type="submit"
                className={cn(
                  "inline-flex items-center justify-center whitespace-nowrap rounded-xl  transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
                  "bg-primary text-primary-foreground shadow ",
                  "h-12 px-4 py-2 my-6",
                  "text-lg font-medium"
                )}
                onClick={() => signIn()}
              >
                {isLoading && <Spinner className="mr-2 h-4 w-4 animate-spin" />}
                Get OTP
              </button>
            </div>
          </div>
          {!isDelete && <div className="px-2 flex flex-col justify-center items-center w-full">
            <div className="text-slate-700 text-sm font-normal ">
              Back to Sign up?
            </div>
            <button
              type="submit"
              className={cn(
                "inline-flex items-center justify-center whitespace-nowrap rounded-xl  transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
                "border border-primary bg-transparent shadow-sm hover:bg-accent  text-accent-foreground",

                "h-12 w-full px-4 py-2 mt-1",
                "text-lg font-medium"
              )}
              onClick={() => gotoSignup()}
            >
              Sign up here
            </button>
          </div>}
        </div>
      </div>
    </>
  );
}
